import { stripHTML } from '../utils'
import { z } from 'zod'
import { apiPriorArtSchema, priorArtSchema } from './prior-art'
import { paginationSchema } from './pagination'
import { highlightCountsSchema } from './highlight-counts'

export const savedSectionSchema = z
  .object({
    section: z.string(),
    text: z.string().transform((text) => stripHTML(text, true, true)),
    index1: z.number(),
    index2: z.number(),
  })
  .describe('Saved Section Schema')

export const apiResultsPriorArtSchema = apiPriorArtSchema
  .extend({
    saved_sections: z.array(savedSectionSchema).default([]),
    highlight_counts: highlightCountsSchema.nullable().default(null),
    x: z.number().nullable().default(null),
    use_for_refinement: z.boolean().optional(),
    id: z.string().optional(),
  })
  .describe('Prior Art Schema')

export type PriorArtApiData = z.infer<typeof apiResultsPriorArtSchema>

export const apiPriorArtSchemaWithFamilyMembers = apiResultsPriorArtSchema
  .extend({
    family_members: z.array(
      apiResultsPriorArtSchema.omit({ family_members: true })
    ),
  })
  .describe('Prior Art Schema with Family Members')

export type PriorArtTypeAPI = z.infer<typeof apiPriorArtSchemaWithFamilyMembers>

export const resultsPageSchema = z
  .object({
    pagination: paginationSchema,
    results: z.array(priorArtSchema),
  })
  .describe('Results Page Schema')

export type PriorArtPageResponse = z.infer<typeof resultsPageSchema>
